.ak{flex-shrink:0;}